// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_SyncResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Subscriptions_SubscriptionSyncRow } from './Subscriptions_SubscriptionSyncRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SetupFee_SyncResponseDados {
franquia_id: number
rows: Subscriptions_SubscriptionSyncRow[]
}

export type SetupFee_SyncResponse = ApiResponse<SetupFee_SyncResponseDados>;

registerResponseContract('SetupFee_SyncResponse', {
  franquia_id: { type: 'number',  required: true },
  rows: {
    type: 'array',
    required: true,
    items: {
      charge_id:     { type: 'string',  required: false },
      remote_status: { type: 'string',  required: false },
      action:        { type: 'string',  required: false },
      detail:        { type: 'string',  required: false },
      lane:          { type: 'string',  required: false },
    },
  },
})
